import store from '@/store'

export default [
  {
    path: '/disciplinary-letters',
    name: 'disciplinary-letter',
    meta: { requiresAuth: true },
    component: () => import('@/pages/disciplinary-letter/index.vue')
  },
  {
    path: '/disciplinary-letters/create',
    name: 'disciplinary-letter-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/disciplinary-letter/create.vue')
  },
  {
    path: '/disciplinary-letters/:id',
    name: 'disciplinary-letter-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/disciplinary-letter/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('disciplinaryLetter/find', to.params.id)
      next()
    }
  }
]
